import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { GenericSnackBarData } from '@r1-compass-library/models';

@Component({
    selector: 'r1-compass-lib-generic-snack-bar',
    template: `
        <div
            class="generic-snack-bar-container"
            [class.clickable]="!!data.action"
            (click)="onAction($event)"
            (keydown.enter)="onAction($event)"
            (keydown.space)="onAction($event)"
            [attr.tabindex]="data.action ? 0 : null"
            [attr.role]="data.action ? 'button' : null"
        >
            @for (message of data.messages; track $index) {
                <div class="generic-snack-bar-message-container">
                    {{ message }}
                </div>
            }
            @if (data.actionText) {
                <button mat-flat-button class="button-white" (click)="onAction($event)" type="button">
                    {{ data.actionText }}
                </button>
            }
            @if (data.showDismissButton) {
                <button mat-flat-button class="button-white" (click)="onDismiss($event)" type="button">Dismiss</button>
            }
        </div>
    `,
    styleUrls: ['./generic-snack-bar.component.scss'],
    imports: [MatButtonModule],
    encapsulation: ViewEncapsulation.None,
})
export class GenericSnackBarComponent {
    readonly #matSnackBarService = inject(MatSnackBar);
    data = inject<GenericSnackBarData>(MAT_SNACK_BAR_DATA);

    onAction(event?: Event): void {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        if (this.data.action) {
            this.data.action();
            this.#matSnackBarService.dismiss();
        }
    }

    onDismiss(event?: Event): void {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        this.#matSnackBarService.dismiss();
    }
}
